import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MIPSCard from '../../../../components/NewEncounter/MIPSCard'
import { saveMIPSData } from '../../../../helper/backendHelper'
import { updatePanelMips } from '../../../../redux/sidePanel/sidePanelThunk'
import { setMipsMeasures } from '../../../../redux/sidePanel/sidePanelSlice'
import { changeMIPSdata } from '../../../../redux/progressNote/progressNoteSlice'

export default function PanelQualityCard() {
  const dispatch = useDispatch()

  const encounterId = useSelector((state) => state.sidePanel.panelEncounter?._id)
  const sharedServiceProviderId = useSelector(
    (state) => state.sidePanel.panelEncounter?.incident_to_provider_id,
  )
  const mips = useSelector((state) => state.sidePanel.panelMipsMeasures)

  const panelChart = useSelector((state) => state.sidePanel.panelChart)
  const chartSignedOn = useSelector((state) => state.sidePanel.panelChart?.signed_on)
  const chartSignedUserId = useSelector((state) => state.sidePanel.panelChart?.signed_user_id)
  const chartCosignedOn = useSelector((state) => state.sidePanel.panelChart?.cosigned_on)

  const providerId = useSelector((state) => state?.user?.provider?._id)

  const noteClosed = sharedServiceProviderId
    ? chartCosignedOn || (chartSignedOn && providerId === chartSignedUserId)
    : chartSignedOn

  return (
    <div id={'PanelQualityCard'}>
      <MIPSCard
        mipsValueData={mips}
        setMipsValueData={async (newMipsData) => {
          dispatch(setMipsMeasures({ mips: newMipsData, useLastAnswers: false }))
          let mipsPayload = newMipsData
            ?.map((mips) => ({
              measureKey: mips?.measureKey,
              value: mips?.value?.label,
              option_data: mips?.value,
            }))
            ?.filter((item) => item?.value)
          await saveMIPSData(encounterId, mipsPayload)
          dispatch(updatePanelMips())
          if (!noteClosed && panelChart) {
            dispatch(
              changeMIPSdata(
                newMipsData.map((mip) => {
                  // Notes require the MIPS value to be the label string
                  return { ...mip, value: mip?.value?.label }
                }),
              ),
            )
          }
        }}
        startAccordionClosed={false}
      />
    </div>
  )
}
